import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import EnergyStep from "../../../components/EnergyStep";
import NetZeroContent from "../../../components/NetZeroContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const NetZeroConsulting = () => {
  const { t } = useTranslation();
  const consulting = t("it.netZero.consulting", { returnObjects: true }) as { title: string; list: { name: string; text: string }[] };
  const simulation = t("it.netZero.simulation", { returnObjects: true }) as { title: string; list: { name: string; text: string }[] };

  return (
    <>
      <Seo title={t("it.netZero.seo.title")} description={t("it.netZero.seo.des")} path="esg-rnd/carbon-neutral-energy" />
      <TitleFormat text={t("it.netZero.title")} />
      <EnergyStep />
      <NetZeroContent title={consulting.title} name_color="#43583c" list={consulting.list} />
      <NetZeroContent title={simulation.title} name_color="#bcb0a2" list={simulation.list} />
      <div className="blank" style={{ maxWidth: 1920, width: "100%", height: 160 }}></div>
    </>
  );
};

export default NetZeroConsulting;
